<template>
  <div>
    <!-- Editable InfoWindow Name -->
    <v-text-field
      v-if="editing"
      id="nameInput"
      v-model="enteredName"
      style="width:100%"
      class="editing-header-color info-window-heading name slim"
      :label="placeholder"
      hide-details="auto"
      single-line
      bg-color="#ebebeb"
      variant="plain"
      @mousedown.stop
      @blur="$emit('updateName', enteredName)"
    />
    <!-- Salesforce Link InfoWindow Name -->
    <a
      v-else-if="link?.type === 'salesforce'"
      :href="link.url"
      target="_blank"
      rel="noopener noreferrer"
      class="info-window-heading sfLink"
    >
      {{ infoWindowName }}
      <img
        class="salesforceIcon"
        src="https://storage.googleapis.com/beyond_maps_public/Icons_Browser/Salesforce-Icon.png"
      >
    </a>
    <!-- Normal InfoWindow Name -->
    <p
      v-else-if="infoWindowName"
      class="info-window-heading name"
      data-testid="info-window-name"
    >
      {{ infoWindowName }}
    </p>
    <!-- Title Divider -->
    <div v-if="infoWindowName || (!infoWindowName && editing)">
      <hr id="titleDivider">
      <hr class="titleDividerLine">
    </div>
  </div>
</template>

<script lang="ts">
import {Link} from '@/lib/classes/Link.js';

export default {
  name: 'InfoWindowName',
  props: {
    infoWindowName: {
      type: [String, null],
      default: null,
    },
    placeholder: {
      type: String,
      default: 'Building Name',
    },
    editing: {
      type: Boolean,
      default: false,
    },
    link: {
      type: [Link, null],
      default: null,
    },
  },
  emits: ['updateName'],
  data() {
    return {
      enteredName: this.infoWindowName,
    };
  },
  watch: {
    // Watcher for when the infoWindowName prop updates
    infoWindowName(newVal) {
      this.enteredName = newVal;
    },
  },
};
</script>

<style scoped lang="scss">
// Default name styling
#nameInput {
  text-align: left;
}

.name {
  text-align: left;
  letter-spacing: 0px;
  cursor: text;
  :deep(.v-field) {
    font-size: 20px;
  }
  :deep(.v-field__input) {
    padding: 6px;
  }
}

.editing-header-color {
  color: rgb(61, 70, 68);
  :deep(.v-field__input) {
    color: rgb(61, 70, 68);
  }
}

.slim {
  :deep(.v-field) {
    border-radius: 2px;
  }
  :deep(.v-field__field) {
    background-color: #ebebeb;

    &:hover {
      background-color: #ebebeb;
    }
  }
  :deep(.v-field__input) {
    min-height: 0;
  }
  :deep(.v-field__outline) {
    display: none;
  }
  :deep(.v-label.v-field-label) {
    font-size: unset;
    top: unset;
    margin: unset;
    padding: 3px 6px;
  }
}

// Salesforce link styling
.sfLink {
  text-decoration: none;
  text-align: left;
  letter-spacing: 0px;
  display: inline-flex;
  align-items: center;
  margin-left: -5px;
  max-width: 400px;
}

.sfLink:hover {
  cursor: pointer;
  text-decoration: underline;
  color: main.$linkBlue;
}

.salesforceIcon {
  height: 20px;
  opacity: 0;
  transform: translateX(-15px);
  transition: all .2s;
  position: relative;
}

.sfLink:hover > .salesforceIcon {
  opacity: 1;
  transform: translateX(5px);
  transition: all .4s;
}

// Title divider styling
#titleDivider {
  border: 2px solid main.$npOrange;
  opacity: 1;
  width: 46px;
  background-color: main.$npOrange;
  margin-top: .5rem;
  margin-bottom: 0;
}

.titleDividerLine {
  margin-top: 0;
  margin-bottom: .5rem;
}
</style>
